import React, { useState } from 'react';
import { toast } from 'sonner';
import { Card, PrimaryButton } from '../ui';
import { adminApi } from '../../../pages/journey/journeyApi';

const SUPPORT = [['weeks', 'Support weeks'], ['checkins', 'Check-ins'], ['milestone_reviews', 'Milestone reviews'], ['specialist_reviews', 'Specialist reviews']];
const inp = 'w-full border border-slate-200 rounded-xl px-3 py-2 text-sm';

const ProgramCard = ({ p, onSaved }) => {
  const [f, setF] = useState(p);
  const save = async () => {
    try { const r = await adminApi(`/programs/${p.id}`, { method: 'PUT', body: { price: +f.price, tagline: f.tagline, support: Object.fromEntries(SUPPORT.map(([k]) => [k, +f.support[k]])) } }); toast.success('Program updated'); onSaved(r); }
    catch (e) { toast.error(e.message); }
  };
  return (
    <Card data-testid={`program-edit-${p.id}`}>
      <p className="font-outfit font-semibold text-[#0b1f4d] mb-3">{p.name}</p>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 text-sm">
        <label>Price (₹)<input type="number" value={f.price} onChange={(e) => setF({ ...f, price: e.target.value })} className={inp} data-testid={`program-price-${p.id}`} /></label>
        {SUPPORT.map(([k, l]) => <label key={k}>{l}<input type="number" value={f.support[k]} onChange={(e) => setF({ ...f, support: { ...f.support, [k]: e.target.value } })} className={inp} data-testid={`program-${k}-${p.id}`} /></label>)}
      </div>
      <label className="block text-sm mt-3">Tagline<input value={f.tagline} onChange={(e) => setF({ ...f, tagline: e.target.value })} className={inp} /></label>
      <PrimaryButton onClick={save} className="mt-3" data-testid={`program-save-${p.id}`}>Save</PrimaryButton>
    </Card>
  );
};

export const AdminPrograms = ({ catalog, setCatalog }) => (
  <div className="space-y-4 max-w-4xl" data-testid="admin-programs">
    <p className="text-sm text-slate-600">One-time prices only. Support periods and review counts are sample prototype values. Edit them per program; they are not final commercial commitments. Changes apply to new enrollments.</p>
    {catalog.programs.filter((p) => p.purchasable).map((p) => (
      <ProgramCard key={p.id} p={p} onSaved={(r) => setCatalog({ ...catalog, programs: catalog.programs.map((x) => (x.id === r.id ? r : x)) })} />))}
    <p className="text-xs text-slate-500">{catalog.access_terms}</p>
  </div>
);
